// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* https://github.com/jensimmons/cssremedy
 * ========================================================================== */

/**
 * Maintain \`hidden\` behaviour when overriding \`display\` values:
 * https://css-tricks.com/the-hidden-attribute-is-visibly-weak/
 */

[hidden] {
  display: none !important;
}

/**
 * Overflow by default is bad
 */

pre {
  white-space: pre-wrap;
}

/**
 * 1. Block display is usually what we want
 * 2. Remove strange space-below when inline
 * 3. Responsive by default
 */

img,
svg,
video,
canvas,
iframe,
audio {
  display: block;
  vertical-align: middle;
  max-width: 100%;
}

/**
 * Maintain intrinsic aspect ratios when \`max-width\` is applied
 * (\`iframe\` has no intrinsic ratio, so its \`height\` needs to be set explicitly)
 */

img,
svg,
video,
canvas {
  height: auto;
}

/**
 * There is no good reason elements default to 300px,
 * and audio files are unlikely to come with a width attribute
 */

audio {
  width: 100%;
}

/* https://github.com/csstools/sanitize.css
 * ========================================================================== */

/**
 * 1. Prevent double cell borders
 * 2. Use evenly sized numbers to line them up under each other
 */

table {
  border-collapse: collapse;
  font-variant-numeric: tabular-nums;
}

/**
 * Let users resize multi-line text fields on their own
 */

textarea {
  resize: vertical;
  resize: block;
}

/* Custom rules
 * ========================================================================== */

/**
 * Prevent overflow caused by long words when absolutely necessary
 */

html {
  overflow-wrap: break-word;
}

/*
 * 1. Thin horizontal line
 * 2. Modernize \`border-style\` (instead of \`inset\`)
 */

hr {
  border-top-width: 1px;
  border-style: solid;
}

/**
 * Valid use cases for \`<u>\` are usually indicated by a wavy underline:
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/u#Usage_notes
 */

u {
  text-decoration-style: wavy;
}
`, "",{"version":3,"sources":["webpack://./node_modules/css-homogenizer/base.css"],"names":[],"mappings":"AAAA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,wBAAwB;AAC1B;;AAEA;;EAEE;;AAEF;EACE,qBAAqB;AACvB;;AAEA;;;;EAIE;;AAEF;;;;;;EAME,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE;;AAEF;;;;EAIE,YAAY;AACd;;AAEA;;;EAGE;;AAEF;EACE,WAAW;AACb;;AAEA;+EAC+E;;AAE/E;;;EAGE;;AAEF;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;+EAC+E;;AAE/E;;EAEE;;AAEF;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE;;AAEF;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;;EAGE;;AAEF;EACE,2BAA2B;AAC7B","sourcesContent":["/* https://github.com/jensimmons/cssremedy\n * ========================================================================== */\n\n/**\n * Maintain `hidden` behaviour when overriding `display` values:\n * https://css-tricks.com/the-hidden-attribute-is-visibly-weak/\n */\n\n[hidden] {\n  display: none !important;\n}\n\n/**\n * Overflow by default is bad\n */\n\npre {\n  white-space: pre-wrap;\n}\n\n/**\n * 1. Block display is usually what we want\n * 2. Remove strange space-below when inline\n * 3. Responsive by default\n */\n\nimg,\nsvg,\nvideo,\ncanvas,\niframe,\naudio {\n  display: block;\n  vertical-align: middle;\n  max-width: 100%;\n}\n\n/**\n * Maintain intrinsic aspect ratios when `max-width` is applied\n * (`iframe` has no intrinsic ratio, so its `height` needs to be set explicitly)\n */\n\nimg,\nsvg,\nvideo,\ncanvas {\n  height: auto;\n}\n\n/**\n * There is no good reason elements default to 300px,\n * and audio files are unlikely to come with a width attribute\n */\n\naudio {\n  width: 100%;\n}\n\n/* https://github.com/csstools/sanitize.css\n * ========================================================================== */\n\n/**\n * 1. Prevent double cell borders\n * 2. Use evenly sized numbers to line them up under each other\n */\n\ntable {\n  border-collapse: collapse;\n  font-variant-numeric: tabular-nums;\n}\n\n/**\n * Let users resize multi-line text fields on their own\n */\n\ntextarea {\n  resize: vertical;\n  resize: block;\n}\n\n/* Custom rules\n * ========================================================================== */\n\n/**\n * Prevent overflow caused by long words when absolutely necessary\n */\n\nhtml {\n  overflow-wrap: break-word;\n}\n\n/*\n * 1. Thin horizontal line\n * 2. Modernize `border-style` (instead of `inset`)\n */\n\nhr {\n  border-top-width: 1px;\n  border-style: solid;\n}\n\n/**\n * Valid use cases for `<u>` are usually indicated by a wavy underline:\n * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/u#Usage_notes\n */\n\nu {\n  text-decoration-style: wavy;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
